import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';

export const companyProfileSteps = () => {
  const roleId = Number(decryptData(Cookies.get('role_id')));
  const isAdmin = roleId === 1 || roleId === 2;
  return [
    {
      target: '[data-tour="company-profile-card"]',
      title: '🏢 Company Profile',
      content: 'This shows your company logo, name and contact details.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="company-profile-logo"]',
      title: '🖼️ Company Logo',
      content: 'Your company logo is displayed here.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="company-profile-edit"]',
      title: '✏️ Edit Profile',
      content: 'Click here to edit your company details.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="company-profile-tabs"]',
      title: '📑 Company Tabs',
      content: isAdmin
        ? 'Use these tabs to navigate between Overview, Address, Policies, Department, Designation, Statutory, and Reporting sections.'
        : 'Use these tabs to navigate between Overview, Address, Policies, and other company information.',
      disableBeacon: true,
    },
  ];
};
